/* FAQ page accordion + category nav.
   Differs from the homepage up-faq.js on purpose:
   - Items are INDEPENDENT: opening one does not close the others
     (measured on the reference: clicking a second question left the
     first one open).
   - The category sidebar (desktop only) highlights the group currently
     in view via IntersectionObserver, and clicking a category jump-
     scrolls to it. */

(function () {
  var sections = document.querySelectorAll('.up-faq-page');

  sections.forEach(function (section) {
    var items = section.querySelectorAll('.up-faq-page__item');

    items.forEach(function (item) {
      var toggle = item.querySelector('.up-faq-page__toggle');
      var panel = item.querySelector('.up-faq-page__panel');

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          panel.style.height = '0px';
        } else {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          panel.style.height = panel.scrollHeight + 'px';
        }
      });
    });

    var navItems = section.querySelectorAll('[data-up-faq-nav]');
    if (!navItems.length) return;

    navItems.forEach(function (nav) {
      nav.addEventListener('click', function () {
        var target = document.getElementById(nav.getAttribute('data-target'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var groups = section.querySelectorAll('.up-faq-page__group');
    var navByTarget = {};
    navItems.forEach(function (nav) {
      navByTarget[nav.getAttribute('data-target')] = nav;
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var nav = navByTarget[entry.target.id];
          if (!nav) return;
          if (entry.isIntersecting) {
            navItems.forEach(function (n) {
              n.classList.remove('is-active');
            });
            nav.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );

    groups.forEach(function (group) {
      observer.observe(group);
    });

    // Fallback for the last group: if it is short, the page can run out of
    // scroll room before it ever crosses the observer's activation band, so
    // it would never light up. Force it active once the user has reached
    // (or nearly reached) the bottom of the document.
    var lastNav = navItems[navItems.length - 1];

    // Horizon does not scroll the window. Its .page-wrapper is the scroll
    // container (overflow: auto) while html and body sit at overflow: hidden
    // pinned to viewport height, so window.scrollY reads 0 and
    // documentElement.scrollHeight equals the viewport height. Measure the
    // element that actually scrolls; the window is only the fallback.
    function scrollHost() {
      var wrap = document.querySelector('.page-wrapper');
      return wrap && wrap.scrollHeight > wrap.clientHeight + 1 ? wrap : null;
    }

    function checkBottom() {
      var host = scrollHost();
      var atBottom = host
        ? host.clientHeight + host.scrollTop >= host.scrollHeight - 2
        : window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      if (atBottom && lastNav) {
        navItems.forEach(function (n) {
          n.classList.remove('is-active');
        });
        lastNav.classList.add('is-active');
      }
    }

    var host = scrollHost();
    if (host) host.addEventListener('scroll', checkBottom, { passive: true });
    window.addEventListener('scroll', checkBottom, { passive: true });
  });
})();
